import { useEffect, useMemo, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import TAGS_QUERY from '../queries/TAGS_QUERY';
import { getFormattedDate, getFormattedDateTime } from '../../utils';

const useTags = () => {
    const [ tags, setCertificates ] = useState( [] );
    const [ fetchTags, { data, loading, error } ] = useLazyQuery( TAGS_QUERY, { fetchPolicy: 'network-only' } );

    useEffect( () => {
        fetchTags();
    }, [] );
    
    useEffect( () => {
        if ( loading || error || !data || !data.tags?.edges ) { return; }
        
        try {
            const result = data.tags.edges.map( i => { 
                return {
                    id: i.node.id || '',
                    key: i.node.id || '',
                    name: i.node.name || '',
                    createdAt: getFormattedDate( i.node.createdAt ),
                    createdAtFull: getFormattedDateTime( i.node.createdAt ),
                    updatedAt: getFormattedDate( i.node.updatedAt ),
                    updatedAtFull: getFormattedDateTime( i.node.updatedAt ),
                }; 
            } );

            setCertificates( 
                result.sort( ( a, b ) => ( a.name?.toLowerCase() || '' ).localeCompare( ( b.name?.toLowerCase() || '' ) ) )
            );
        } catch ( error ) {
            console.error( 'Error parsing tags', error ); 
            setCertificates( [] );
        }
    }, [ loading, error ] );
   
    return useMemo( () => {
        return {
            tags,
            fetchTags,
            tagsError: error,
            tagsLoading: loading
        };
    }, [ tags, error, loading ] );
};

export default useTags;
